module.exports = __webpack_public_path__ + "static/media/footer-banner@2x.62232362.jpg";